import { RouteObject } from 'react-router-dom'

import routes from 'core/routes'

import { HomeView } from './Home'
import { RewardsView } from './Rewards'
import { ScoreView } from './Score'
import { SweepstakesView } from './sweepstakes'
import { UserProfile } from './UserProfile'

export const consoleViewsRoutes: RouteObject[] = [
  {
    index: true,
    element: <HomeView />,
  },
  {
    path: routes.app.console.scores,
    element: <ScoreView />,
  },
  {
    path: routes.app.console.rewards,
    element: <RewardsView />,
  },
  {
    path: routes.app.console.userProfile,
    element: <UserProfile />,
  },
  {
    path: routes.app.console.sweepstakes,
    element: <SweepstakesView />,
  },
]
